var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Application',{ref:"application",attrs:{"from-preview":true,"loaded":_vm.loaded,"showApplication":_vm.showApplication,"loadingQuestions":_vm.loadingQuestions,"info":_vm.info},on:{"apply":_vm.apply}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }